module.exports = function() {
  return new Worker(__webpack_public_path__ + "296ad711ce977e4fbcdb.worker.js");
};